import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

function InsightCharges () {
  const { setPageName } = useOutletContext();

  useEffect(() => {
    setPageName('Insights');
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
        <h4 className="header-title">Financiero</h4>
        </div>
      </div>
    </div>

  );
}

export default InsightCharges;